import Keycloak from "keycloak-js";
import { keycloakService } from "services/authService";

export interface IKeycloakSSOConfig {
    usernamePattern?: RegExp;
    idpHint?: string;   
}

export const keycloakSSOLoginStrategy = (config: IKeycloakSSOConfig) => {
    return (username: string) => {
        if (config.usernamePattern.test(username)) {
            const keycloak = new Keycloak({
                url: process.env.REACT_APP_API_AUTH + "/auth",
                realm: process.env.REACT_APP_API_AUTH_REALM,
                clientId: process.env.REACT_APP_API_AUTH_CLIENT_ID,
            });

            keycloak
                .init({
                checkLoginIframe: true,
                })
                .then((authenticated) => {
                if (authenticated) {
                    window.location.href = window.location.origin + "/app/dashboard";
                } else {
                    keycloak.login({
                    redirectUri: window.location.origin + "/app/dashboard",
                    idpHint: config.idpHint,
                    }).then(()=> {
                        const access_token = keycloak.token;
                        keycloakService.defaults.headers[
                            "Authorization"
                          ] = `Bearer ${access_token}`;
                    }
                    )
                }
                });
        }
    }
}

export const tryRedirectToSSO = (username: string) => {
    const config = keycloakSSOConfigs.find((config) => config.usernamePattern.test(username))

    if (config) {
        keycloakSSOLoginStrategy(config)(username);
        return true;
    }

    return false;
}

const ElCorteInglesLoginConfig: IKeycloakSSOConfig = {
    usernamePattern: /(?:^C\d{5}[A-Z]{2}$|^E2P[^@]*$)/,
    idpHint: 'saml',
}

export const keycloakSSOConfigs = [
    ElCorteInglesLoginConfig
]